import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  CardTitle,
  Button
} from 'reactstrap';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {Colxx} from '../components/common/CustomBootstrap';
import ModalManager from '../components/modal/ModalManager';
import {reactTableText} from '../constants/configs';
import {keyBy, mapValues} from 'lodash';
import {i18nizeDate} from '../helpers/Utils';
import {NotificationManager} from '../components/common/react-notifications';
import DescriptionForm from './DescriptionForm';
import Api from '../services/Api';
import Rbac from '../components/Rbac';

class Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: [],
      pages: -1,
      loading: false,
    };
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/user-descriptions',
        null,
        {
          params: {
            userId: this.props.userId,
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? mapValues(keyBy(state.filtered, 'id'), 'value') : null),
          }
        },
      );
      this.setState({
        notes: data.descriptions,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  deleteDescription = async id => {
    const {t} = this.props;
    try {
      await Api.invoke(
        'DELETE',
        '/admin-ui/user-descriptions',
        null,
        {params: {id}}
      );
      NotificationManager.success(t('Note deleted successfully'), t('Message'));
      this.table.fireFetchData();
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressDelete = id => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete this note ?'),
      buttons: [
        {
          color: 'primary',
          onClick: () => {
            this.deleteDescription(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  renderDescriptionForm = note => {
    return (
      <DescriptionForm
        note={note}
        userId={this.props.userId}
        fireFetchData={() => {this.table.fireFetchData();}}
      />
    );
  };

  onPressEdit = note => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Edit Note'),
      body: this.renderDescriptionForm(note),
    });
  };

  onPressCreate = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Create Note'),
      body: this.renderDescriptionForm(),
    });
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  getColumns = t => [
    {
      Header: t('Admin'),
      accessor: 'adminUsername',
      width: 200,
      Cell: props => <span>{`${props.original.adminFirstName ? `${props.original.adminFirstName} ${props.original.adminLastName} ` : ''}[${props.value}]`}</span>,
    },
    {
      Header: t('Description'),
      accessor: 'description',
      Cell: props => <span className='font-weight-semibold'>{props.value}</span>
    },
    {
      Header: t('Register Date'),
      accessor: 'createdAt',
      width: 140,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('Update Date'),
      accessor: 'updatedAt',
      width: 140,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('Actions'),
      width: 75,
      Cell: props => {
        return (
          localStorage.getItem('username') === props.original.adminUsername ?
          <div>
            <Rbac permission="delete_user-descriptions">
              <i className="simple-icon-trash delete-icon mx-3 cursor-pointer"
                 onClick={() => {this.onPressDelete(props.original.id);}}
              />
            </Rbac>
            <Rbac permission="update_user-descriptions">
              <i className="simple-icon-pencil edit-icon mx-3 cursor-pointer"
                 onClick={() => {this.onPressEdit(props.original);}}/>
            </Rbac>
          </div> : null
        );
      },
      show: Rbac.hasPermission('update_user-descriptions') || Rbac.hasPermission('delete_user-descriptions')
    },
  ];

  render() {
    const {t} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary d-flex flex-row justify-content-between align-items-center">
                {t('Admins Notes')}
                <Rbac permission='create_user-descriptions'>
                  <Button onClick={this.onPressCreate}>
                    <i className="simple-icon-plus add-reply-icon"/>
                    <span className="mx-1">{t('Add')}</span>
                  </Button>
                </Rbac>
              </CardTitle>
              <ReactTable
                manual
                ref={el => {this.table = el;}}
                className="-highlight"
                data={this.state.notes}
                pages={this.state.pages}
                loading={this.state.loading}
                sortable={false}
                resizable={true}
                expanded={this.state.expanded}
                onPageChange={() => {this.setState({expanded: {}});}}
                onExpandedChange={this.onExpanded}
                onFetchData={this.fetchData}
                columns={this.getColumns(t)}
                defaultPageSize={5}
                style={{
                  width: '100%'
                }}
                {...reactTableText}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(Notes);
